export const ListQueryKey = 'activityHllqRecords';
export const DetailQueryKey = 'activityRecommendRecord';
export const Urls = {
  selectUrl: '/rewardCenterExchange/list',
  updateUrl: '/rewardCenterExchange/update',
  deleteUrl: '/rewardCenterExchange/delete',
  createUrl: '/rewardCenterExchange/create',
  detailUrl: '/rewardCenterExchange/info'
}; // /api/rewardCenterExchange/list